    import React from 'react';
    import AboutOne from '../../components/About/AboutOne'; // Adjust the import path as needed
    import CounterOne from '../../components/About/CounterOne';
    import videoImg from '../../assets/images/resources/counter-one-img-1.jpg';
    import WhyAreWe from '../../components/About/WhyAreWe';
    import image1 from '../../assets/images/resources/why-are-we-img-1.jpg';
    import image2 from '../../assets/images/resources/why-are-we-img-2.jpg';
    import TestimonialsSection from '../../components/About/TestimonialsSection';
    import care from '../../assets/svgs/care.svg';
    // import banner from '../../assets/images/backgrounds/about.png';
    import Banner from './Banner';

    const AboutMain = () => {
    
        const points = [
            {   iconClass: care,
                title: 'Transparency, Honesty and Trust',
                subtext: 'We’re obsessed with tracking every minute and mile, and we provide that visibility to you.'
            },
            {
                iconClass: care,
                title: 'On time delivery',
                subtext: 'We’re obsessed with tracking every minute and mile, and we provide that visibility to you.'
            },
            {
                iconClass: care,
                title: 'On time delivery',
                subtext: 'We’re obsessed with tracking every minute and mile, and we provide that visibility to you.'
            },
            {
                iconClass: care,
                title: 'On time delivery',
                subtext: 'We’re obsessed with tracking every minute and mile, and we provide that visibility to you.'
            },
            {
                iconClass: care,
                title: 'On time delivery',
                subtext: 'We’re obsessed with tracking every minute and mile, and we provide that visibility to you.'
            }
        
        ];
        
        const teamMembers = [
            {
                name: 'John Doe',
                designation: 'CEO',
                image: 'https://onpoint-alpha.vercel.app/assets/images/team/team-1-1.jpg',
                social: [
                    {
                        icon: 'icon-facebook-f',
                        url: 'https://www.facebook.com'
                    },
                    {
                        icon: 'icon-Vector',
                        url: 'https://www.twitter.com'
                    },
                    {
                        icon:   'icon-linkedin-in',
                        url: 'https://www.linkedin.com'
                    }   
                ]
            },
            {
                name: 'John Doe',
                designation: 'CTO',
                image: 'https://onpoint-alpha.vercel.app/assets/images/team/team-1-1.jpg',
                social: [
                    {
                        icon: 'icon-facebook-f',
                        url: 'https://www.facebook.com'
                    },
                    {
                        icon: 'icon-Vector',
                        url: 'https://www.twitter.com'
                    },
                    {
                        icon:   'icon-linkedin-in',
                        url: 'https://www.linkedin.com'
                    }   
                ]
            },
            {
                name: 'John Doe',
                designation: 'Claims Manager',
                image: 'https://onpoint-alpha.vercel.app/assets/images/team/team-1-1.jpg',
                social: [
                    {
                        icon: 'icon-facebook-f',
                        url: 'https://www.facebook.com'
                    },
                    {
                        icon: 'icon-Vector',
                        url: 'https://www.twitter.com'
                    },
                    {
                        icon: 'icon-linkedin-in',
                        url: 'https://www.linkedin.com'
                    }   
                ]
            },
            {
                name: 'John Doe',
                designation: 'CEO',
                image: 'https://onpoint-alpha.vercel.app/assets/images/team/team-1-1.jpg',
                social: [
                    {
                        icon: 'icon-facebook',
                        url: 'https://www.facebook.com'
                    },

                    {
                        icon: 'icon-Vector',
                        url: 'https://www.twitter.com'
                    },
                    {
                        icon:   'icon-linkedin-in',
                        url: 'https://www.linkedin.com'
                    }   
                ]
            },
            {
                name: 'John Doe',
                designation: 'CTO',
                image: 'https://onpoint-alpha.vercel.app/assets/images/team/team-1-1.jpg',
                social: [
                    {
                        icon: 'icon-facebook-f',
                        url: 'https://www.facebook.com'
                    },
                    {
                        icon: 'icon-Vector',
                        url: 'https://www.twitter.com'
                    },
                    {
                        icon:   'icon-linkedin-in',
                        url: 'https://www.linkedin.com'
                    }   
                ]
            },
            {
                name: 'John Doe',
                designation: 'Claims Manager',
                image: 'https://onpoint-alpha.vercel.app/assets/images/team/team-1-1.jpg',
                social: [
                    {
                        icon: 'icon-facebook-f',
                        url: 'https://www.facebook.com'
                    },
                    {
                        icon: 'icon-Vector',
                        url: 'https://www.twitter.com'
                    },
                    {
                        icon:   'icon-linkedin-in',
                        url: 'https://www.linkedin.com'
                    }   
                ]
            }


        ];
        
        return (
            <React.Fragment>
                <AboutOne />

                {/* different section */}
                <div className='container' style={{margin: '120px 120px',}}>
                    <div className='row gy-4  '>
                        <div className='col-xl-4'>
                            <div className='about-one__left'>
                                <h1 style={{fontWeight: '700', color: '#006FB4',fontFamily: 'Montserrat'}} className="text-bold">
                                        What makes <br />
                                        us different
                                    </h1>
                                <p className='mt-3' style={{fontSize: '18px',color: '#2A2A2A',fontFamily: 'Montserrat',fontWeight: '400'}}>
                                We optimize every mile for speed, <br />
                                cost, and efficiency—delivering <br />
                                beyond expectations.
                                </p>
                            </div>
                        </div>
                            {points.map((point, index) => (
                                <div className='col-xl-4'>
                                        <div  style={{backgroundColor: '#EAF7FF',borderRadius: '30px',padding: '40px',minHeight: '360px'}} key={index} className=''>
                                            <img className='mb-4' src={point.iconClass} alt={point.title} />
                                            <h1 style={{fontSize: '22px',fontWeight: '500',color: '#2A2A2A',fontFamily: 'Montserrat'}}>{point.title}</h1>
                                            <p className='mt-4' style={{fontSize: '18px',color: '#2A2A2A',fontFamily: 'Montserrat',fontWeight: '400'}}>{point.subtext}</p>
                                        </div>
                                </div>
                            ))}

                    </div>
                </div>
                <Banner />

                <div className='' style={{margin: '120px 100px'}}>
                    <div className='row'>
                        <div className='col-xl-12'>
                            <h1 style={{fontSize: '62px',fontWeight: '700',color: '#2A2A2A',fontFamily: 'Montserrat',color: '#006FB4'}}>
                                Meet Our Leadership 
                            </h1>
                            <p className='mt-3' style={{fontSize: '18px',color: '#2A2A2A',fontFamily: 'Montserrat',fontWeight: '400',width: '50%'}}>  
                             A team of industry experts driving innovation, efficiency, and excellence in logistics. With strategic vision and deep expertise, we ensure seamless operations and customer success.
                            </p>
                        </div>
                        <div className='col-xl-12 row mt-5'>
                            {teamMembers.map((member, index) => (
                                <div className='col-xl-4 p-2'>
                                    <div style={{backgroundColor: '#EAF7FF',borderRadius: '30px',padding: '25px'}}  className='d-flex justify-content-start align-items-center gap-4'>
                                    
                                        <img style={{borderRadius: '50%'}} src={member.image} alt={member.name} />
                                        <div  >
                                        <h4 style={{fontSize: '18px',fontWeight: '600',color: '#2A2A2A',fontFamily: 'Montserrat'}}>       
                                             {member.name}
                                        </h4>
                                        <h6 className='mt-3' style={{fontSize: '14px',color: '#2A2A2A',fontFamily: 'Montserrat',fontWeight: '400'}}>
                                            {member.designation}</h6>
                                        <div className='d-flex gap-4 mt-4'>
                                            {member.social.map((social, index) => (
                                                <a  href={social.url} key={index}>
                                                    <span style={{width:"20px",height:"20px"}} className={social.icon}></span>
                                                </a>
                                            ))}
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>


                {/* banner section */}
              
                {/* <CounterOne
                    imageSrc={videoImg}
                    videoId="jNQXAC9IVRw" // YouTube video ID
                    videoCaption="Watch our video"
                    tagline="Our Features"
                    title="Simplifying your logistics of the challenges"
                    description="Logistic service involves the planning, implementation, and control of the efficient and effective movement and storage of goods and materials."
                    counters={counters}
                />
                <TestimonialsSection/>
                <WhyAreWe
                    imageSrc1={image1}
                    imageSrc2={image2}
                    tagline="Why are we best"
                    title="Efficiency at its best with our logistics services"
                    points={points}
                    year="Since 1920"
                    yearDescription="Logistic service involves the planning, implementation, and control of the efficient and effective movement and storage"
                /> */}
            </React.Fragment>
        );
    };

    export default AboutMain;
